var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_13408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73926 6.00028H12.0001C12.0001 5.45874 11.9279 4.93411 11.7934 4.43506H5.73926V6.00028Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73926 2.86943H11.1195C10.7522 2.27008 10.2826 1.74032 9.73502 1.3042H5.73926V2.86943Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00053 12.0001C7.41262 12.0001 8.71051 11.5121 9.73544 10.6958H2.26562C3.29055 11.5121 4.58844 12.0001 6.00053 12.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.880977 9.13017H11.1197C11.4146 8.64902 11.6432 8.12308 11.7936 7.56494H0.207031C0.35743 8.12308 0.586109 8.64902 0.880977 9.13017Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77931 0.936984H3.32609L2.81749 1.30648L3.01177 1.90434L2.5032 1.53485L1.99462 1.90434L2.16244 1.38785C1.71464 1.76086 1.32216 2.19788 0.998719 2.68481H1.17391L0.850172 2.92001C0.799734 3.00415 0.751359 3.08962 0.705 3.17637L0.859594 3.65217L0.571172 3.44262C0.499477 3.59452 0.433898 3.74984 0.374953 3.90839L0.545273 4.43264H1.17391L0.66532 4.80213L0.859594 5.4L0.351023 5.03051L0.0463828 5.25185C0.0158906 5.49696 0 5.74662 0 6H6C6 2.68631 6 2.29566 6 0C4.81472 0 3.7098 0.343828 2.77931 0.936984ZM3.01177 5.4L2.5032 5.03051L1.99462 5.4L2.1889 4.80213L1.6803 4.43264H2.30895L2.5032 3.83477L2.69745 4.43264H3.32609L2.81749 4.80213L3.01177 5.4ZM2.81749 3.0543L3.01177 3.65217L2.5032 3.28268L1.99462 3.65217L2.1889 3.0543L1.6803 2.68481H2.30895L2.5032 2.08695L2.69745 2.68481H3.32609L2.81749 3.0543ZM5.16394 5.4L4.65537 5.03051L4.1468 5.4L4.34107 4.80213L3.83248 4.43264H4.46112L4.65537 3.83477L4.84962 4.43264H5.47826L4.96966 4.80213L5.16394 5.4ZM4.96966 3.0543L5.16394 3.65217L4.65537 3.28268L4.1468 3.65217L4.34107 3.0543L3.83248 2.68481H4.46112L4.65537 2.08695L4.84962 2.68481H5.47826L4.96966 3.0543ZM4.96966 1.30648L5.16394 1.90434L4.65537 1.53485L4.1468 1.90434L4.34107 1.30648L3.83248 0.936984H4.46112L4.65537 0.339117L4.84962 0.936984H5.47826L4.96966 1.30648Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_13408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.ca6e282eea8a7ac49e19f1cc18dadc01.svg";
export { ForwardRef as ReactComponent };